function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import { ApiConstants, InjectorHelper, SessionSelectors, ThunkHelper } from 'invision-core';
import { CouponSearchRecordCountSelector } from '../selectors/search.coupon.selectors';
import { CurrentCouponRedemptionCodeSelector } from '../selectors/coupon.redemption.code.selectors';
import { hideSearchPanel } from './search.actions';
export var COUPON_SEARCH = {
  BEGIN: 'COUPON_SEARCH_BEGIN',
  SUCCESS: 'COUPON_SEARCH_SUCCESS',
  FAILURE: 'COUPON_SEARCH_FAILURE'
};
var COUPON_SEARCH_EVENTS = [COUPON_SEARCH.BEGIN, COUPON_SEARCH.SUCCESS, COUPON_SEARCH.FAILURE];
export var SET_COUPON_SEARCH_MODEL = 'SET_COUPON_SEARCH_MODEL';
export var setCouponSearchModel = function setCouponSearchModel(payload) {
  return {
    type: SET_COUPON_SEARCH_MODEL,
    payload: payload
  };
};
export var RESET_SEARCH_COUPON_MODEL_RECOVERABLE = 'RESET_SEARCH_COUPON_MODEL_RECOVERABLE';
export var resetCouponSearchRecoverable = function resetCouponSearchRecoverable() {
  return {
    type: RESET_SEARCH_COUPON_MODEL_RECOVERABLE
  };
};
export var getCouponSearchByIdPromise = function getCouponSearchByIdPromise(dispatch, redemptionCodeId, pageNumber, pageSize) {
  var data = {
    CouponRedemptionCodeId: redemptionCodeId
  };
  return getCouponSearchPromise(dispatch, data, pageNumber, pageSize);
};
export var getCouponSearchByRedemptionCodePromise = function getCouponSearchByRedemptionCodePromise(dispatch, redemptionCode, pageNumber, pageSize) {
  var data = {
    RedemptionCode: redemptionCode
  };
  return getCouponSearchPromise(dispatch, data, pageNumber, pageSize);
};
var getCouponSearchPromise = function getCouponSearchPromise(dispatch, data, pageNumber, pageSize) {
  var events = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : COUPON_SEARCH_EVENTS;
  var $ngRedux = InjectorHelper.getNgReduxService();
  var state = $ngRedux.getState();
  return ThunkHelper(dispatch, events, {
    method: 'post',
    url: 'SubscriberManagement/SearchCouponRedemptions',
    headers: _defineProperty({}, ApiConstants.CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, SessionSelectors.LanguageHeaderSelector(state)),
    data: data
  });
};
export var getCouponSearch = function getCouponSearch(couponSearchModel, pageNumber, pageSize) {
  return function (dispatch, getState) {
    var searchTask;
    if (couponSearchModel.redemptionCode) {
      searchTask = getCouponSearchByRedemptionCodePromise(dispatch, couponSearchModel.redemptionCode, pageNumber, pageSize);
    } else if (couponSearchModel.redemptionCodeId) {
      searchTask = getCouponSearchByIdPromise(dispatch, couponSearchModel.redemptionCodeId, pageNumber, pageSize);
    }
    return searchTask.then(function () {
      if (CouponSearchRecordCountSelector(getState()) === 1) {
        var couponCodeThumbnail = CurrentCouponRedemptionCodeSelector(getState());
        if (!couponCodeThumbnail.CouponRedemptionCode.SubscriberId) {
          dispatch(routeToCouponCode(couponCodeThumbnail));
        } else {
          dispatch(routeToCustomerCouponCode(couponCodeThumbnail));
        }
      }
    });
  };
};
export var routeToCouponCode = function routeToCouponCode(couponCodeThumbnail) {
  // Defaults state and params
  var state = 'index.customercare.coupon';
  var params = {
    couponRedemptionCodeId: couponCodeThumbnail.CouponRedemptionCode.Id
  };
  return function (dispatch) {
    dispatch(stateGo(state, params, {
      reload: true
    }));
    dispatch(hideSearchPanel());
  };
};
export var routeToCustomerCouponCode = function routeToCustomerCouponCode(couponCodeThumbnail) {
  // Defaults state and params
  var state = 'index.customercare.customer.coupons.details';
  var params = {
    customerId: couponCodeThumbnail.CouponRedemptionCode.SubscriberId,
    couponRedemptionCodeId: couponCodeThumbnail.CouponRedemptionCode.Id
  };
  return function (dispatch) {
    dispatch(stateGo(state, params, {
      reload: true
    }));
    dispatch(hideSearchPanel());
  };
};